<div class="asGraph">
  <svg viewBox="0 0 124 28" xmlns="http://www.w3.org/2000/svg">
    <line
      *ngFor="let m of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
      [attr.x1]="m * 10"
      [attr.x2]="m * 10"
      [attr.y1]="yStart"
      [attr.y2]="yEnd"
      stroke="black"
      stroke-width="0.2"
    />

    <rect *ngFor="let p of drawPoints"
      [attr.x]="p.x - (pointSize / 2)"
      [attr.y]="p.y - (pointSize / 2)"
      [attr.width]="pointSize"
      [attr.height]="pointSize"
      [attr.class]="p.class"
      rx="1.2">
      @if(p.title) {
        <title>{{ p.title }}</title>
      }
    </rect>

    <text
      class="monthticks"
      [attr.x]="m.x"
      [attr.y]="textY"
      *ngFor="let m of monthTicks"
    >
      {{ m.label }}
    </text>
  </svg>
</div>
